import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import { accountCollection } from "#root/schema/account";
import { correspondenceCollection } from "#root/schema/correspondence";
import type { ReactNode } from "react";

import PageLayout from "./layout";

export default function ({ correspondenceId }): ReactNode {
  return (
    <PageLayout title="Billing - Edit Correspondence">
      <section>
        <h2>Edit Correspondence</h2>
        <StandardEditor id={correspondenceId} collection={correspondenceCollection}>
          <Fields.Set name="id">
            <Fields.Hidden/>
          </Fields.Set>
          <Fields.Set name="accountId">
            <label>Account</label>
            <Fields.AutoComplete required collection={accountCollection}/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="date">
            <label>Date</label>
            <Fields.Timestamp/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="reference">
            <label>Reference ID</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="status">
            <label>Send Status</label>
            <Fields.Select>
              <Fields.Option value="SENT">Sent</Fields.Option>
              <Fields.Option value="UNSENT">Unsent</Fields.Option>
            </Fields.Select>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="from">
            <label>From</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="to">
            <label>To</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="cc">
            <label>CC</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="bcc">
            <label>Bcc</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="subject">
            <label>Subject</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="bodyFormat">
            <label>Body Format</label>
            <Fields.Select>
              <Fields.Option value="HTML">HTML</Fields.Option>
              <Fields.Option value="MARKDOWN">Markdown</Fields.Option>
              <Fields.Option value="TEXT">Text</Fields.Option>
            </Fields.Select>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="body">
            <label>Body</label>
            <Fields.TextArea rows={10}/>
            <Fields.Validity/>
          </Fields.Set>
        </StandardEditor>
      </section>
    </PageLayout>
  );
}
